import React from "react";
import {Link} from "react-router-dom";

import display from "@/services/display-name";
import {IProjectDocumentModel} from "./models";

import {getDocumentUrl} from "@/components/project/import/FileStatus";
import Highlighter from "@toolbox/display-blocks/Highlighter";

interface IDocumentLinkProps {
    idSuffix: string;
    value: IProjectDocumentModel;

    highlighter?: string;
    textDotOverflow?: boolean;
}

class DocumentLink extends React.PureComponent<IDocumentLinkProps> {
    public render() {
        const url = this.getUrl();
        const {
            idSuffix,
            value: {id, name},
            textDotOverflow,
        } = this.props;

        if (!url || !name) {
            if (textDotOverflow) {
                return (
                    <em className="d-flex text-muted">
                        <span className="text-dot-overflow">
                            {this.renderName()}
                        </span>
                    </em>
                );
            }

            return <em className="text-muted">{this.renderName()}</em>;
        }

        if (textDotOverflow) {
            return (
                <Link id={id + "-" + idSuffix} className="d-flex" to={url}>
                    <span className="text-dot-overflow">
                        {this.renderName()}
                    </span>
                </Link>
            );
        }

        return (
            <Link id={id + "-" + idSuffix} to={url}>
                {this.renderName()}
            </Link>
        );
    }

    private renderName() {
        const {
            value: {name},
            highlighter,
        } = this.props;

        return (
            <Highlighter
                query={highlighter}
                text={!name ? display.default : name}
            />
        );
    }

    private getUrl() {
        const {id, project, type, deviceClass} = this.props.value;

        if (!id || id.toString().startsWith("~")) {
            return undefined;
        }

        return getDocumentUrl(id, project ?? 0, type, deviceClass);
    }
}

export default DocumentLink;
